/**
 * Created by hp on 2017/6/29.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import WKDialog from '../components/WKDialog';
import {renderMoney} from '../utils';

import '../styles/GiftDialog2.css';

class GiftDialog2 extends Component {
    constructor() {
        super();
        this.plusbtnHandler = this.plusbtnHandler.bind(this);
        this.subbtnHandler = this.subbtnHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.giftNumSelHandler = this.giftNumSelHandler.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    plusbtnHandler() {
        let {giftNum, money} = this.props.gift;
        this.props.dispatch({
            type: 'GIFT_RESET',
            payload: {
                lecturePrice: (giftNum + 1) * money,
                closeText: '打包' + (giftNum + 1) + '份赠礼',
                giftNum: giftNum + 1,
                giftValueSelected: 0
            }
        });
    }

    subbtnHandler() {
        let {giftNum, money} = this.props.gift;
        giftNum = giftNum === 1 ? 1 : (giftNum - 1);
        this.props.dispatch({
            type: 'GIFT_RESET',
            payload: {
                lecturePrice: giftNum * money,
                closeText: '打包' + giftNum + '份赠礼',
                giftValueSelected: 0,
                giftNum: giftNum
            }
        });
    }

    submitHandler() {
        this.props.dispatch({type: 'GIFT_HIDE_DIALOG'});
        let {productId, giftNum, payType, payProduct, paySuccessUrl, payProductKey, paySubProductKey, subProductId} = this.props.gift;
        let params = {
            product: payProduct,
            gift_count: giftNum
        };
        params[payProductKey] = productId;

        if (paySubProductKey) {
            params[paySubProductKey] = subProductId;
        }

        this.props.dispatch({
            type: payType,
            payload: {
                params: params,
                success: () => {
                    this.props.dispatch({type: 'GIFT_HIDE_DIALOG'});
                    window.location = paySuccessUrl;
                }
            }
        });
    }

    giftNumSelHandler(e) {
        let {money} = this.props.gift;
        let giftValueSelected = parseInt(e.currentTarget.dataset.value, 10);

        this.props.dispatch({
            type: 'GIFT_RESET',
            payload: {
                giftValueSelected: giftValueSelected,
                lecturePrice: parseInt(giftValueSelected * money, 10),
                closeText: '打包' + giftValueSelected + '份赠礼',
                giftNum: giftValueSelected,
            }
        });
    }

    onRequestClose() {
        this.props.dispatch({type: 'GIFT_HIDE_DIALOG'});
        this.props.dispatch({
            type: 'GIFT_RESET',
            payload: {
                lecturePrice: 0,
                giftValueSelected: 1,
            }
        });
    }

    render() {
        let {giftNum, money, showGiftDialog, closeText, giftValueFirst, giftValueSecond, giftValueSelected, lecturePrice} = this.props.gift;

        return (
            <div className="gift-dialog">
                <WKDialog
                    title={<span style={{color: '#3cc51f', fontSize: '1.1rem'}}>豪爽赠礼给好友</span>}
                    closeText={closeText}
                    onClick={this.submitHandler}
                    onRequestClose={this.onRequestClose}
                    show={showGiftDialog}>
                    <div className="cs-number-item">
                        <div className="gift-num-text">赠送数量</div>
                        <div className="weui-flex git-num-box">
                            {giftValueFirst.map((v, i) => (
                                <span key={v} className={"weui-flex__item " + (i === 1 && "gift-middle")} data-value={v}
                                      onClick={this.giftNumSelHandler}>
                                    <a
                                        className={giftValueSelected === v ? "weui-btn weui-btn_primary gift-num-selected" : "weui-btn weui-btn_plain-default gift-num"}>
                                      {v}
                                    </a>
                                </span>
                            ))}
                        </div>
                        <div className="weui-flex git-num-box">
                            {giftValueSecond.map((v, i) => (
                                <span key={v} className={"weui-flex__item " + (i === 1 && "gift-middle")} data-value={v}
                                      onClick={this.giftNumSelHandler}>
                                    <a
                                        className={giftValueSelected === v ? "weui-btn weui-btn_primary gift-num-selected" : "weui-btn weui-btn_plain-default gift-num"}>
                                      {v}
                                    </a>
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="weui-flex cs-number-item">
                        <div className="weui-flex__item">豪爽赠送</div>
                        <div className="weui-flex__item weui-flex cs-gift-num">
                            <a href="#" className="cs-number-sub cs-number"
                               onClick={this.subbtnHandler}>-</a>
                            <input pattern="[0-9]*" type="number" className="cs-number-input" value={giftNum} min="1"
                                   disabled/>
                            <a className="cs-number-plus cs-number"
                               onClick={this.plusbtnHandler}>+</a>
                        </div>
                        <div className="weui_cell_ft" style={{display: "none"}}> 0</div>
                    </div>

                    <div className="weui-flex cs-number-item cs-gift-total-money">
                        <div className="weui-flex__item text-right cs-gift-total">
                            <p className="total" style={{margin: '0 auto'}}>
                                总计：￥{lecturePrice ? renderMoney(lecturePrice) : renderMoney(money)}
                            </p>
                            <p className="text-medium">好友可免费领取，永久有效</p>
                        </div>
                    </div>
                </WKDialog>
            </div>
        )
    }
}

export default connect((state) => ({
    gift: state.gift,
}))(GiftDialog2)


// WEBPACK FOOTER //
// ./src/components/GiftDialog2.js